import {createSelector} from 'reselect';

import {getUIState} from '../ui-selectors';

const getTasksUIState = createSelector([getUIState], (uiState) => uiState.messages);

export const getDismissedMessages = createSelector(
    [getTasksUIState],
    (dismissedMessages) => dismissedMessages.dismissedMessageIds
);
